/* eslint no-prototype-builtins: "off" */

/**
 * Config handler allow to bind events and load the bundles from the config
 *
 * @module core/configHandler
 * @requires core/container
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */

'use strict';

const mediator = require('./mediator');

/**
 * Put events to the mediator
 *
 * @example configHandler.handleEvents({
 *   events: {
 *     'my-event': [
 *        {'callback': (data) => {console.log('hello world')} }
 *     ]
 *   },
 * });
 * @param  {object} config
 */
const handleEvents = (config) => {
  if (!(typeof config === 'object')) {
    throw new Error('ConfigHandler.handleEvents: expects an object');
  }

  for (let key in config) {
    if (config.hasOwnProperty(key)) {
      config[key].forEach((event) => {
        if (typeof event.callback === 'function') {
          mediator.subscribe(key, event.callback);
        }
      });
    }
  }
};

/**
 * Put events of bundles to the mediator
 *
 * @example configHandler.handleBundles({
 *   events: {
 *     'my-event': [
 *        {'callback': (data) => {console.log('hello world')} }
 *     ]
 *   },
 *   bundles: {
 *     'pages' : {
 *        'events': {
 *           'application:ready': [
 *              {'callback': {console.log('application ready')}},
 *              {'callback': {console.log('hello world')}}
 *           ],
 *           'otherEvent:start': [
 *              {'callback': {console.log('hello world')} }
 *           ]
 *        }
 *     }
 *   }
 * });
 * @param {object} config
 */
const handleBundles = function(config) {
    if (!(typeof config === 'object')) {
        throw new Error('ConfigHandler.handleBundles expects an object');
    }

    for (let key in config) {
      if (config.hasOwnProperty(key)) {
        let bundle = config[key];
        if (bundle.events) {
          handleEvents(bundle.events);
        }
      }
    }
};

/**
 * Initialize events and bundles
 *
 * @example configHandler.init({
 *   bundles: {
 *     'pages' : {
 *        'events': {
 *           'application:ready': [
 *              {'callback': {console.log('application ready')}},
 *              {'callback': {console.log('hello world')}}
 *           ],
 *           'otherEvent:start': [
 *              {'callback': {console.log('hello world')} }
 *           ]
 *        }
 *     }
 *   }
 * });
 * @function init
 * @fires config:ready
 * @param  {object} config
 */
module.exports.init = function(config) {
    if (!(typeof config === 'object')) {
        throw new Error('ConfigHandler.init : expects an object');
    }

    if (config.bundles) {
        handleBundles(config.bundles);
    }

    if (config.events) {
        handleEvents(config.events);
    }

    mediator.publish('config:ready');
};

module.exports.handleEvents = handleEvents;
